import EditarPerfil from '../components/EditarPerfil'

let routes = {
    path: '/editar-perfil',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/editar-perfil',
            name: 'EditarPerfil',
            component: EditarPerfil
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/editar_perfil.js